<template>
  <div class="flex reverse align-flex-end mt-0 mb-10">
    <div class="box" v-if="buttonsViews.length > 0">
      <el-button-group>
        <button-view
          v-for="(view, index) in buttonsViews"
          ref="button-view"
          :key="index"
          :icon="view.icon"
          :default="index === 0"
          @button-view-click="changeView(view.component, index)"
        />
      </el-button-group>
    </div>

    <!-- search wrapper -->
    <div class="box mr-5" v-if="filterables">
      <el-input
        icon="search"
        size="mini"
        style="width: 320px"
        clearable
        v-model="search"
        :placeholder="filterPlaceholder"
        @keyup.native.enter.prevent="filterSearch()"
        @clear="filterSearch()"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="filterSearch()"
        ></el-button>
      </el-input>
    </div>

    <div class="box mr-5" v-if="callNew !== undefined">
      <el-button
        title="Crear"
        round
        type="primary"
        icon="el-icon-plus"
        size="mini"
        @click="callNew"
      ></el-button>
    </div>

    <!-- Quieres agregar columna, aca debe de ser -->
    <slot></slot>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import ButtonView from "./ButtonView";

export default {
  name: "RabbeyToolbox",
  events: ["filter-search"],
  props: {
    filterPlaceholder: {
      type: String,
      default: "Buscar"
    },
    filterables: {
      type: Boolean,
      default: false
    },
    buttonsViews: {
      type: Array,
      default: () => []
    },
    callNew: {
      type: Function,
      default: undefined,
      required: false
    },
    justify: {
      type: String,
      default: "end"
    }
  },
  components: {
    "button-view": ButtonView
  },
  data() {
    return {
      search: "",
      formOpen: false,
      buttonTypeGrid: "default",
      gutter: 0
    };
  },
  created() {
    window.addEventListener("keydown", this.doCommand);
  },
  destroyed() {
    window.removeEventListener("keydown", this.doCommand);
  },
  watch: {
    search(val) {
      if (val === "" || val === null || val === undefined) {
        this.$emit("filter-search", "");
      }
    }
  },
  computed: {
    /**
     * El objectivo de computed es calcular las migajas de pan.
     * En estara en deshuso hasta que termine bien como se manejara este tema.
     */
    crumbs() {
      let pathArray = this.$route.path.split("/");
      pathArray.shift();
      let breadcrumbs = pathArray.reduce((breadcrumbArray, path, idx) => {
        breadcrumbArray.push({
          path: path,
          to: breadcrumbArray[idx - 1]
            ? "/" + breadcrumbArray[idx - 1].path + "/" + path
            : "/" + path,
          text: this.$route.matched[idx].meta.breadCrumb || path
        });
        return breadcrumbArray;
      }, []);
      return breadcrumbs;
    }
  },
  methods: {
    ...mapMutations({
      setLoading: "rabbey_table/loading",
      setSuccess: "rabbey_table/success"
    }),
    filterSearch() {
      // this.setLoading();
      this.$emit("filter-search", this.search);
      // this.closeForm();
    },
    onClickOutside() {
      this.formOpen = false;
    },
    openForm() {
      this.formOpen = true;
    },
    closeForm() {
      setTimeout(this.onClickOutside, 100);
    },
    changeView(component, index) {
      this.$emit("change-view", component);

      // Buscar el boton clickeado y activa el button y los demas los desactiva
      for (let i = 0; i < this.$refs["button-view"].length; i++) {
        const currentView = this.$refs["button-view"][i];
        if (index === i) {
          currentView.buttonType = "primary";
        } else {
          currentView.buttonType = "default";
        }
      }
    },
    doCommand(event) {
      if (event.isComposing || event.keyCode === 229) {
        return;
      }

      // let cmd = String.fromCharCode(event.keyCode).toLowerCase();
      // do stuff
      if (event.altKey && event.keyCode === 67) {
        this.callNew();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables";

.card-form {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  box-sizing: border-box;
  overflow: hidden;

  .footer {
    margin-bottom: 0 !important;
  }

  .flex {
    display: flex;
    align-content: flex-start;

    .box {
      align-self: center;
    }
  }

  .body {
    padding: 20px;
  }

  &:not(.open) {
    padding: 0px;
    border-radius: 50px !important;

    &:hover {
      box-shadow: 0 3px 6px 0 rgba(40, 40, 90, 0.09),
        0 1px 1px 0 rgba(0, 0, 0, 0.065);
    }
  }

  &.open {
    z-index: 2;
    position: absolute;
    box-shadow: 0 3px 6px 0 rgba(40, 40, 90, 0.09),
      0 1px 1px 0 rgba(0, 0, 0, 0.065);
  }
}
</style>
